import React from 'react'
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function Header() {
    
    const location = useLocation();
    let currentPath = location.pathname
    const { t, i18n } = useTranslation();
    let languages = {
        en : {code: 'en', name: 'English'},
        fr : {code: 'fr', name: 'Français'}
    }
    let notCurrentLanguage = languages.fr
    if (i18n.language==='fr') {
        notCurrentLanguage = languages.en
    }
    return (
        <div className="knsl-top-bar">
            <div className="container">
                <div className="knsl-left-side">
                <Link to="/" className="knsl-logo-frame">
                    <img src="assets/img/logo.svg" alt={t('main.siteName')} />
                </Link>
                </div>
                <div className="knsl-right-side">
                <div className="knsl-menu">
                    <nav>
                    <ul>
                        <li className={currentPath==='/'?"current-item":""}>
                        <Link to="/">{t('main.home')}</Link>
                        </li>
                        <li className={currentPath==='/about'?"current-item":""}>
                        <Link to="/about">{t('main.about')}</Link>
                        </li>
                        <li className={currentPath.includes('/room')?"current-item":""}>
                        <Link to="/rooms">{t('main.rooms')}</Link>
                        </li>
                        <li className={currentPath==='/contact'?"current-item":""}>
                        <Link to="/contact">{t('main.contact')}</Link>
                        </li>
                        <li className={(currentPath==='/blog' || currentPath.includes('/post'))?"menu-item-has-children current-item":"menu-item-has-children"}>
                        <Link to="/blog">{t('main.infoNews')}</Link>
                            <ul>
                                <li><Link to="/blog?filter=news">{t('main.newsPromotions')}</Link></li>
                                <li><Link to="/blog?filter=covid">{t('main.infoCovid')}</Link></li>
                                <li><Link to="/restaurant">{t('main.restaurant')}</Link></li>
                            </ul>
                        </li>
                        <li>
                            <a href='/#' onClick={evt => {evt.preventDefault(); i18n.changeLanguage(notCurrentLanguage.code)}}>{notCurrentLanguage.name}</a>
                        </li>
                    </ul>
                    </nav>
                </div>
                <button  id="book-popup" className="knsl-btn"><img src="assets/img/icons/bookmark.svg" alt="icon"/>{t('main.bookNow')}</button>
                </div>
                <div className="knsl-menu-btn"><span></span></div>
            </div>
            </div>
    );
}

export default Header as React.FC